/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { commonResponse, PaginationParams } from '../models/common.model';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { notificationPayload, notificatonList, userListData } from '../models/notification.model';
import { apiList } from '../core/constants/apiList.const';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(
    private readonly http: HttpClient ) {}

  addNotification(payload: notificationPayload): Observable<commonResponse<null>['data']> {
    return this.http
      .post<commonResponse<null>>(`${environment.base_url}${apiList.addNotification}`, payload).pipe(map(res => res.data));
  }

  getNotificationList(body: PaginationParams): Observable<notificatonList> {
    return this.http
      .post<{
        data: notificatonList;
      }>(`${environment.base_url}${apiList.getNotification}`, body, { headers: { 'X-Exclude-Toaster': 'true' } })
      .pipe(map(res => res.data));
  }

  deleteNotification(id: string): Observable<commonResponse<null>['data']> {
    return this.http
      .delete<commonResponse<null>>(
        `${environment.base_url}${apiList.deleteNotification}${id}/`
      )
      .pipe(map(res => res.data));
  }
  getUserList(body: any): Observable<commonResponse<userListData>['data']> {
    return this.http
      .post<commonResponse<userListData>>(
        `${environment.base_url}${apiList.userList}`, body, { headers: { 'X-Exclude-Toaster': 'true' } }
      ).pipe(map(res => res.data));
  }

  getAdminNotification(body: PaginationParams): Observable<notificatonList> {
    return this.http
      .post<{
        data: notificatonList;
      }>(`${environment.base_url}${apiList.adminNotification}`, body, { headers: { 'X-Exclude-Toaster': 'true' } })
      .pipe(map(res => res.data));
  }
}
